import React from 'react';

import ListPreviewCard from 'components/AggregationCards/ListPreview';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Section from 'components/Section';
import GroupSelectUserContainer from 'containers/UserList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';
import { htmlT } from 'utils/generic';

import { Scaffold } from '../../styles';

interface Props {
  onConfirmSelection: (users: GroupedListModel[]) => void;
  onCloseModal: () => void;
  onAdd: () => void;
  showUserSelection: boolean;
  users: GroupedListModel[];
  groupTarget: string;
}

const GroupUsers = ({ users, groupTarget, showUserSelection, onCloseModal, onAdd, onConfirmSelection }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Section title={t('group.participants.title')} details={htmlT(t, 'group.participants.details')} joinContent>
      <ApplicationOverlayContent sidebar show={showUserSelection} onClose={onCloseModal}>
        <Scaffold title={t('group.participants.title')}>
          <GroupSelectUserContainer
            isModal
            title={t('group.groupAggregation.title')}
            subTitle={groupTarget}
            alreadySelected={users}
            selectableType="check"
            onConfirmSelection={onConfirmSelection}
            onCloseSelectionScreen={onCloseModal}
          />
        </Scaffold>
      </ApplicationOverlayContent>
      <ListPreviewCard
        showInitials
        placeholder={t('group.participants.addUser')}
        icon="user"
        multipleColumns
        previewItems={
          users ? users.map((item) => ({ title: `${item.name} ${item.lastName}`, subtitle: item.email })) : []
        }
        onAdd={onAdd}
        onClick={onAdd}
      />
    </Section>
  );
};

export default GroupUsers;
